__turbopack_context__.v({
  "alwaysShow": "collection-feedback-module-scss-module__RiEpha__alwaysShow",
  "body": "collection-feedback-module-scss-module__RiEpha__body",
  "button": "collection-feedback-module-scss-module__RiEpha__button",
  "buttonContainer": "collection-feedback-module-scss-module__RiEpha__buttonContainer",
  "icon": "collection-feedback-module-scss-module__RiEpha__icon",
  "invert": "collection-feedback-module-scss-module__RiEpha__invert",
  "link": "collection-feedback-module-scss-module__RiEpha__link",
  "message": "collection-feedback-module-scss-module__RiEpha__message",
  "slide": "collection-feedback-module-scss-module__RiEpha__slide",
  "thumbsIcon": "collection-feedback-module-scss-module__RiEpha__thumbsIcon",
});
